import $api from "@/frontend/shared/api/axios";

export async function deleteProfilePhoto() {
  return $api.delete("/me/profile-photo");
}
